var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReliabilityIcon = function SvgReliabilityIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#reliability_icon_svg__a)",
    d: "M16 11.5c5.235 0 9.575 3.831 10.37 8.843a9.72 9.72 0 0 1 6.88-2.843H40v3.75A9.75 9.75 0 0 1 30.25 31H26.5v7.5h-3v-12h-3C14.701 26.5 10 21.799 10 16v-4.5zm21 9h-3.75a6.75 6.75 0 0 0-6.75 6.75V28h3.75A6.75 6.75 0 0 0 37 21.25zm-21-6h-3V16a7.5 7.5 0 0 0 7.5 7.5h3V22a7.5 7.5 0 0 0-7.5-7.5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "reliability_icon_svg__a",
    x1: 10,
    x2: 40,
    y1: 25,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335CFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#335CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF",
    stopOpacity: 0.8
  })))));
};
export default SvgReliabilityIcon;